// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__QDGnw","detailsBorder":"styles_detailsBorder__UMSjv"};